import React from 'react';
import {
  Button, SimpleForm,AutocompleteArrayInput, SelectArrayInput, ReferenceArrayInput, Toolbar,
  TextField, Datagrid, Edit, Create, List, DateField, Filter, TextInput, SaveButton, required,
  FormDataConsumer, useListContext, CreateButton, NumberInput, BooleanInput} from 'react-admin';
import RunReportIcon from '@material-ui/icons/PlayCircleFilledRounded';
import CloudDownload from '@material-ui/icons/CloudDownload';
import DataTable from 'react-data-table-component';
import { fetchUtils } from 'react-admin';
import { Typography } from "@material-ui/core";
import { ExpandMore } from '@material-ui/icons';
import {Accordion, AccordionSummary, AccordionDetails, Box, Card} from "@material-ui/core";
import FilterCardTitle from '../common/filters/FilterCardTitle';
import { AlertComponent } from '../components/alerts.js';
import { DisclaimerComponent } from '../components/disclaimer.js';
import { LegendComponent } from '../components/legend.js';
import DeleteWithConfirmation from '../components/DeleteWithConfirmation';
import { TotalAuctionOptimizerComponent } from '../Dashboard/components';
const prebidBidders = require('../prebidBidderModules.json');

const choicesAdType = [
  { "id": "banner", "name": "BANNER" },
  { "id": "video",  "name": "VIDEO" }
];
const choicesOptType = [
  { "id": "included", "name": "INCLUDED" },
  { "id": "excluded",  "name": "EXCLUDED" }
];
const choicesDevices = [
  { "id": "Computer", "name": "Desktop" },
  { "id": "Mobile", "name": "Mobile/Tablet" }
];
const countryChoices = require('../components/countries.json');
const browserChoices = require('../components/browsers.json');
const utils = require('../components/utils');
const dataSupport = require('../components/data_support.js');
const fetch = fetchUtils.fetchJson;


const BASE_URL = window.nobid_endpoint+'/carbon/carbonizer_report'
const requestOptions = {headers: new Headers()}
requestOptions.headers.set('accept', 'application/json')
const token = localStorage.getItem('token');
requestOptions.headers.set('Authorization', `Bearer ${token}`);

// https://github.com/jbetancur/react-data-table-component/blob/master/stories/DataTable/Basic/ExportCSV.stories.js
function convertArrayOfObjectsToCSV(array) {
  let result;

  const columnDelimiter = ',';
  const lineDelimiter = '\n';
  let keys = Object.keys(array[0]);
  keys = keys.filter(key => (key!=='code' && key!=='adx_ad_requests' && key!=='id'));

  result = '';
  result += keys.join(columnDelimiter);
  result += lineDelimiter;

  array.forEach(item => {
    let ctr = 0;
    keys.forEach(key => {
      if (key==='code' || key==='adx_ad_requests' || key==='id') return;
      if (ctr > 0) result += columnDelimiter;

      result += item[key];
      // eslint-disable-next-line no-plusplus
      ctr++;
    });
    result += lineDelimiter;
  });

  return result;
}

function downloadCSV(array) {
  array.forEach((row, i) => {
    delete array[i].id
    delete array[i].code
  })
  dataSupport.exportData(array)
}

const choicesShow = [
  { id: 'opt_type', name: 'Optimization Type' },
  { id: 'created_at', name: 'Creation Date' },
  { id: 'period_start', name: 'Period Start' },
  { id: 'period_end', name: 'Period End' },
  { id: 'publisher', name: 'Publisher' },
  { id: 'site', name: 'Site' },
  { id: 'bidder_name', name: 'Bidder' },
  { id: 'country', name: 'Country' },
  { id: 'device', name: 'Device' },
  { id: 'browser', name: 'Browser' },
  { id: 'ad_type', name: 'Ad Type' }
]

const defaultMetrics = [
  { id: 'impressions', name: '#Impressions' },
  { id: 'revenue', name: '#Revenue' },
  { id: 'avg_cpm', name: '$Avg_CPM' },
  { id: 'bid_requests', name: '#Bid Requests' },
  { id: 'bid_responses', name: '#Bid Responses' },
  { id: 'bid_request_rate', name: '%Bid Request Rate' },
  { id: 'bid_response_rate', name: '%Bid Response Rate' },
  { id: 'rpm_bid_requests', name: '$RMP Bid Requests' }
]

const BASE_COLUMNS = [
  { name: 'Creation Date', selector: 'created_at', definition: 'Typically the Optimizer runs every hour and this column shows the date the record was created.' },
  { name: 'Period Start', selector: 'period_start', definition: 'The Optimizer start date selection.' },
  { name: 'Period End', selector: 'period_end', definition: 'The Optimizer end date selection.' },
  { name: 'Publisher', selector: 'publisher_name', sortable: true },
  { name: 'Site', selector: 'site_name', sortable: true },
  { name: 'Site ID', selector: 'site_id', sortable: true },
  { name: 'Bidder', selector: 'bidder_name', sortable: true },
  { name: 'Country', selector: 'country', sortable: true },
  { name: 'Device', selector: 'device', sortable: true, definition: 'The user device. The Optimizer categorizes the devices in 2 categories: DESKTOP or MOBILE.' },
  { name: 'Browser', selector: 'browser', sortable: true },
  { name: 'Ad Type', selector: 'ad_type', sortable: true, definition: 'The ad type BANNER or VIDEO.' },
  { name: 'Optimization Type', selector: 'opt_type', sortable: true, definition: 'The type of optimization EXCLUDED or INCLUDED.' },
  { name: '#Impressions', selector: 'impressions', sortable: true, cell: row => <span>{ utils.formatLong(row.impressions) }</span>, definition: 'Impressions served.' },
  { name: '$Revenue', selector: 'revenue', sortable: true, cell: row => <span>{ utils.formatDouble(row.revenue) }</span>, definition: 'Revenue generated by the impression in the currency defined in the Prebid wrapper.' },
  { name: '$Avg CPM', selector: 'avg_cpm', sortable: true, cell: row => <span>{Number(Number.parseFloat(row.avg_cpm).toFixed(2))}</span>, definition: 'The Average CPM is defined as 1,000 * Revenue / Impressions.'},
  { name: '#Bid Requests', selector: 'bid_requests', sortable: true, cell: row => <span>{ utils.formatLong(row.bid_requests) }</span>, definition: 'The Bid Requests sent from the Prebid wrapper to the Demand sources defined in the Prebid wrapper.' },
  { name: '#Bid Responses', selector: 'bid_responses', sortable: true, cell: row => <span>{ utils.formatLong(row.bid_responses) }</span>, definition: 'The Bid Responses received by the Prebid wrapper from the Demand sources.' },
  { name: '%Bid Request Rate', selector: 'bid_request_rate', sortable: true, cell: row => <span>{ utils.formatDouble(row.bid_request_rate, '%') }</span>, definition: 'The Bid Request Rate is defined as 100 * Impressions / Bid Requests.' },
  { name: '%Bid Response Rate', selector: 'bid_response_rate', sortable: true, cell: row => <span>{ utils.formatDouble(row.bid_response_rate, '%') }</span>, definition: 'The Bid Response Rate is defined as 100 * Bid Responses / Bid Requests.' },
  { name: '$RPM Bid Requests', selector: 'rpm_bid_requests', sortable: true, cell: row => <span>{ utils.formatDouble(row.rpm_bid_requests) }</span>, definition: 'The Revenue Per Million Bid Requests is defined as 1,000,000 * Revenue / Bid Requests.' },
];

const defaultColumnSelectors = ['impressions', 'revenue', 'avg_cpm', 'bid_requests', 'bid_responses', 'bid_request_rate', 'bid_response_rate', 'rpm_bid_requests'];

class CustomToolbar extends React.Component {
  state = {
    data: [],
    loading: false,
    total: 0,
    perPage: 25,
    params : ['_end=1000000', '_order=ASC', '_sort=id', '_start=0'],
    baseUrl: BASE_URL
  };

  constructor(props) {
    super(props);
    this.parent = props.parent;
  }

  fetchData = () => {
    function updateState(that, headers, json) {
      if (!json?.data) return;
      const summary = json.summary || {};
      json = json.data;
      if (json) for (let i in json) {
        let r = json[i];
        if (r.date) r.date = r.date.indexOf('T') > 0 ? r.date.substring(0, r.date.indexOf('T')) : r.date;
      }

      const showList = formData.show || [];
      const columnSelectors = json ? Object.keys(json[0]) : []; // defaultColumnSelectors.concat(showList.flatMap(x=>[x, `${x}_id`, `${x}_name`, `${x}_group`]));

      that.parent.setState({
        summary: summary,
        data: json,
        saved_data:json,
        columns: BASE_COLUMNS.filter(c => columnSelectors.includes(c.selector)),
        loading: false
      });
    }

    formData.show = formData.show || [];
    let show='';
    if (formData.show) formData.show.forEach(item => { show+='&show='+item; });

    this.parent.setState({ loading: true });
    let url = `${this.state.baseUrl}?${show}` +
      `${utils.formDataFieldsQueryStringFormat(
          formData,
          ['created_at', 'period_start', 'period_end', 'publisher_id', 'site_id', 'bidder_name',
          'ad_type', 'device', 'country', 'browser', 'opt_type',
          'simulationEnabled', 'impressions_minimum', 'revenue_minimum', 'bid_responses_rate_minimum',
          'rpm_bid_requests_minimum']
      )}`;
    const requestOptions = {headers: new Headers()}
    requestOptions.headers.set('accept', 'application/json')
    const token = localStorage.getItem('token');
    requestOptions.headers.set('Authorization', `Bearer ${token}`);
    fetch(url, requestOptions).then(({ headers, json }) => {
    	updateState(this, headers, json)
    });
  }
  handleClick = () => {
	  this.fetchData();
  }

  render () {
    return (
      <Toolbar>
        <SaveButton style={{marginRight: '25px'}} variant='contained' 
          color='primary' disabled={this.parent.state.loading} {...this.props} />
        <Button label="Run Report" onClick={this.handleClick} props={this.props} variant="contained"
          style={{marginRight: '25px', padding: '7px', width: '160px'}} color="primary" startIcon={<RunReportIcon />} disabled={this.parent.state.loading}/>
      </Toolbar>
    )
  }
}

const CarbonizerReportTitle = ({ record }) => {
  return <span>Optimizer Report {record ? `"${record.name}"` : ''}</span>;
};

const CarbonizerReportFilters = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="search_name" alwaysOn resettable />
  </Filter>
);

const Empty = () => {
  const { basePath, resource } = useListContext();
  return (
    <Box textAlign="center" m={1}>
      <Typography style={{marginTop: '150px'}} variant="h4" paragraph>
          No Optimizer Reports available
      </Typography>
      <Typography variant="body1">
          Create one
      </Typography>
      <CreateButton style={{marginTop: '50px'}} basePath={basePath} variant='contained'/>
    </Box>
  );
};

export const CarbonizerReportList = ({ permissions, ...props }) => (
  <List {...props} empty={<Empty />} title="Optimizer Reports" perPage={25} bulkActionButtons={false} filters={<CarbonizerReportFilters />} 
  exporter={false} >
    <Datagrid rowClick="edit">
      <TextField source="name" label="Name" />
      <DateField source="updated_at" label="Update Date" />
      <DateField source="created_at" label="Creation Date" />
      <DeleteWithConfirmation {...props}/>
    </Datagrid>
  </List>
);

let formData = {};
function setFormData(formdata) {
  formData = formdata;
}

const hasActiveFilters = (record) => {
  const filters = ['publisher_id', 'site_id', 'bidder_name', 'country', 'adsize', 'ad_type', 'device', 'browser', 'tldomain'];
  return record && filters.some( f => record[f] && record[f].length > 0)
}

class CarbonizerReportComponent extends React.Component {
  state = {
    summary: {},
    data: [],
    loading: false,
    total: 0,
    perPage: 25,
    params : ['_end=1000000', '_order=ASC', '_sort=id', '_start=0'],
    baseUrl: BASE_URL,
    dateRange: this.props.record.date_range
  };

  render() {
    const { loading, data, summary, dateRange } = this.state;
    const { permissions, formType, record } = this.props;

    return (
      <div>
        <AlertComponent />
        <Card>
          <SimpleForm toolbar={<CustomToolbar parent={this} />} style={{ width: '100%', backgroundColor: 'inherit', borderRadius: '5px' }} {...this.props}>
            <TextInput source="name" label="Report Name" style={{ width: '400px' }} validate={required()} />
            <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} id="wrapper2">
              <FormDataConsumer>
                {({ formData }) => setFormData(formData) }
              </FormDataConsumer>
            </div>

            <Accordion defaultExpanded={true} style={{ marginBottom: '20px'}} fullWidth>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <FilterCardTitle title="Dimensions" values={true} />
              </AccordionSummary>
              <AccordionDetails>
              <div style={{alignSelf: 'flex-start', width: '100%'}}>
                <SelectArrayInput label="Show"
                  size="small"
                  source="show" 
                  choices={choicesShow}
                  style={{alignSelf: 'flex-start', width: '100%'}}
                  disabled={loading} />
              </div>
              </AccordionDetails>
            </Accordion>
              
            <Accordion defaultExpanded={formType==="create"} style={{ marginBottom: '20px'}} fullWidth>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <FilterCardTitle title="Filters" values={hasActiveFilters(record)} />
              </AccordionSummary>
              <AccordionDetails>
                <Box style={{ width: '100%' }}>
                  <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} id="wrapper3">
                    <div style={{flex: 1}}>
                      <ReferenceArrayInput 
                        source="publisher_id" 
                        label="Publisher" 
                        reference="publishers"
                        basePath="publishers"
                        perPage={15} 
                        sort={{ field: 'name', order: 'ASC' }}
                        filterToQuery={searchText => ({ search_name: searchText })}
                        allowEmpty
                        disabled={loading}>
                        <AutocompleteArrayInput disabled={loading}
                          label="Publishers"
                          optionText="name"
                          optionValue="code"
                          fullWidth/>
                      </ReferenceArrayInput>
                    </div>

                    {permissions &&
                      <div style={{flex: 1}}>
                        <ReferenceArrayInput 
                          source="site_id" 
                          label="Site" 
                          reference="sites"
                          basePath='sites'
                          perPage={15} 
                          sort={{ field: 'name', order: 'ASC' }}
                          filterToQuery={searchText => utils.siteFormFilter(searchText, formData)}
                          allowEmpty
                          disabled={loading}>
                          <AutocompleteArrayInput disabled={loading} label="Sites" 
                            optionText={ x => utils.formatSiteName(x) }
                            optionValue="code"
                            fullWidth/>
                        </ReferenceArrayInput>
                      </div>
                    }
                  
                    {permissions && ['admin', 'report_admin'].includes(permissions.role) &&
                      <div style={{flex: 1}}>
                        <AutocompleteArrayInput label="Bidders" 
                        source="bidder_name" 
                        choices={prebidBidders}
                        disabled={loading}
                        fullWidth />
                      </div>
                    }
                  </div>
              
                  <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} >
                    <div style={{flex: 1}}>
                      <SelectArrayInput label="Countries"
                        source="country"
                        choices={countryChoices}
                        disabled={loading}
                        fullWidth/>
                    </div>
                    <div style={{flex: 1}}>
                      <SelectArrayInput label="Devices" 
                        source="device" 
                        choices={choicesDevices} 
                        disabled={loading}
                        fullWidth />
                    </div>
                    <div style={{flex: 1}}>
                      <SelectArrayInput label="Browsers"
                        source="browser"
                        choices={browserChoices}
                        disabled={loading}
                        fullWidth/>
                    </div>
                  </div>

                  <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} >
                    <div style={{flex: 1}}>
                      <SelectArrayInput label="Ad Type" 
                        source="ad_type" 
                        choices={choicesAdType}
                        disabled={loading}
                        fullWidth />
                    </div>
                    <div style={{flex: 1}}>
                      <SelectArrayInput label="Optimization Type" 
                        source="opt_type" 
                        choices={choicesOptType}
                        disabled={loading}
                        fullWidth />
                    </div>
                  </div>
                </Box>
              </AccordionDetails>
            </Accordion>

            <Accordion defaultExpanded={formType==="create"} style={{ marginBottom: '20px'}} fullWidth>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <FilterCardTitle title="Optimization Predictive Analysis" values={hasActiveFilters(record)} />
              </AccordionSummary>
              <AccordionDetails>
              <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} >
                <div style={{flex: 1}}>
                  <div style={{width: '100%'}}>
                    <div style={{display: 'grid'}}>
                    <BooleanInput source='simulationEnabled' label='Enable Predictive Analysis' style={{width: '50%'}}
                    helperText="This enables the simulation just for this report and does not affect the live settings" />

                    <br/>
                    <div>Minimum IMPRESSIONS globally set to 1 impression by default.</div>
                    <NumberInput source="impressions_minimum" defaultValue={1} label="Minimum Impressions" style={{width: '50%'}}
                        helperText="Block inventory where impressions is less or equal to the minimum" />
                    </div>

                    <br/>
                    <div style={{display: 'grid'}}>
                    <div>Minimum REVENUE globally set to $0.001 by default.</div>
                    <NumberInput source="revenue_minimum" defaultValue={0.001} label="Minimum Revenue ($)" style={{width: '50%'}}
                        helperText="Block inventory where revenue is less or equal to the minimum" />
                    </div>

                    <br/>
                    <div style={{display: 'grid'}}>
                    <div>Minimum RESPONSE RATE defined as #bid responses / #bid requests.</div>
                    <NumberInput source="bid_responses_rate_minimum" label="Minimum Response Rate %" style={{width: '50%'}}
                        helperText="Block inventory where bid response rate is less or equal to the minimum (bid responses/bid requests)"/>
                    </div>

                    <br/>
                    <div style={{display: 'grid'}}>
                    <div>Minimum RPM defined as Revenue per Million Bid Requests (1,000,000 * $revenue / #bid requests).</div>
                    <NumberInput source="rpm_bid_requests_minimum" label="Minimum RPM Rate ($)" style={{width: '50%'}}
                        helperText="Block inventory where RPM is less or equal to the minimum (1,000,000 * $revenue/#bid requests)."/>
                    </div>
                  </div>
                </div>
                <div style={{flex: 1}}>
                  <h4>Summary</h4>
                  <span style={{fontSize: 'small'}}>The data used is based on the past 10 days including today. 
                  The Auction Optimizer minimizes wasteful requests resulting in: faster page speed, increased profitability and carbon emissions reduction. 
                  These KPIs are not tracked by the Predictive Analysis.</span><br/><br/>
                  <div style={{ width: '80%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} >
                    <div style={{flex: 1}}>
                      <TotalAuctionOptimizerComponent totalAccepted={summary?.included?.revenue} totalOptimized={summary?.excluded?.revenue} 
                      title={`$ Revenue Risk<br/>${utils.double(summary?.excluded?.revenue_pct || 0,'%')}`}
                      loading={this.state.loading}/>
                    </div>
                    <div style={{flex: 1}}>
                      <TotalAuctionOptimizerComponent totalAccepted={summary?.included?.bid_requests} totalOptimized={summary?.excluded?.bid_requests} 
                      title={`Wastful Requests<br/>${utils.double(summary?.excluded?.bid_requests_pct || 0,'%')}`}
                      loading={this.state.loading}/>
                    </div>
                  </div>
                </div>
              </div>
              </AccordionDetails>
            </Accordion>
          </SimpleForm>
        </Card>
        <div style={{ height: '15px', backgroundColor: 'transparent'}} />
        
        <Card>
          <DataTable
            title="Optimizer Report"
            theme={window.nobid_table_theme()}
            columns={this.state.columns}
            data={data}
            progressPending={loading}
            pagination
            fixedHeader
            paginationPerPage={30}
            paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
            dense
            highlightOnHover
            subHeader={!loading}
            subHeaderComponent={
              (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <input type="text" id='search_box' label="Search" 
                  variant="outlined" 
                  style={{ margin: '5px' }} 
                  onChange={(target) => dataSupport.filterData(this)}/>
                  <CloudDownload 
                  label="Export"
                  style={{ margin: '5px' }} 
                  color="action" 
                  onClick={() => downloadCSV(this.state.data)}
                  />
                </div>
              )
            }
          />
          
          <DisclaimerComponent />

          <LegendComponent columns={BASE_COLUMNS} choices={[...choicesShow, ...defaultMetrics]}/>

        </Card>
      </div>
    )
  }
};

export const CarbonizerReportEdit = (props) => (
  <Edit title={<CarbonizerReportTitle />}  mutationMode="pessimistic" {...props}>
    <CarbonizerReportComponent formType="edit" permissions={props.permissions} {...props} />
  </Edit>
);

export const CarbonizerReportCreate = (props) => (
  <Create title="Create Optimizer Report" mutationMode="pessimistic" {...props}>
    <CarbonizerReportComponent formType="create" permissions={props.permissions} {...props} />
  </Create>
);
